<div class="bn-dialog p-5">
  <div class="bn-dialog__title">{{ title || 'File Upload' }}</div>
  <div
    class="bn-dialog__close pt-3 pe-4"
    (click)="bsModalRef.hide()">
    <fa-icon
      aria-label="Close"
      class="pull-right"
      icon="xmark" />
  </div>
  <div class="bn-dialog__body">
    <form [formGroup]="uploadFilesForm">
      <bn-web-ui-upload-file
        browseLinkText="Browse"
        formControlName="files"
        [allowedFileTypes]="allowedFileTypes" />
    </form>
  </div>
  @if (buttons?.save?.length) {
    <div class="bn-dialog__actions">
      <button
        aria-label="Save"
        bn-web-ui-button
        leftIcon="floppy-disk"
        (click)="bsModalRef.hide()">
        {{ buttons?.save }}
      </button>
    </div>
  }
</div>
